import {
    IonBadge, IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon,
    IonInfiniteScroll, IonInfiniteScrollContent, IonNote, IonPage, IonProgressBar, IonRow,
    IonSearchbar, IonTitle, IonToolbar, IonLabel, IonRange, IonCardSubtitle,
    IonInput,
    IonText,
    IonSelect,
    IonSelectOption,
    useIonViewDidEnter,
    useIonViewWillLeave
} from "@ionic/react";
import { cart, cartOutline, chevronBackOutline, closeOutline, search, searchOutline } from "ionicons/icons";
import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import ProductCard from "../components/ProductCard";

import { CartStore } from "../data/CartStore";
import { ProductStore } from "../data/ProductStore";

import styles from "./CategoryProducts.module.css";
import { Preferences } from "@capacitor/preferences";

import { getCaptchaToken } from "../Helper";
import axiosCall from "../data/axios";

interface RecentSearch {
    name: string;
    place: string;
    min_price: number;
    max_price: number;
}

const SearchProducts = () => {

    const history = useHistory();

    const params = history.location.state as { data: string, location?: string, priceMin?: number, priceMax?: number };

    const [query, setQuery] = useState<any | null>(params?.data);

    const cartRef = useRef<HTMLIonIconElement>(null);

    const products = ProductStore.useState(s => s.products);
    const shopCart = CartStore.useState(s => s.product_ids);
    const [searchResults, setSearchResults] = useState<any[]>([]);
    const [amountLoaded, setAmountLoaded] = useState(11);
    const [priceCeiling, setPriceCeiling] = useState(0);
    const [priceFloor, setPriceFloor] = useState(0);
    const [priceMin, setPriceMin] = useState(params?.priceMin || 0);
    const [priceMax, setPriceMax] = useState(params?.priceMax || 0);
    function priceKnobChange(event: any) {
        setPriceMin(event.detail.value.lower || 0);
        setPriceMax(event.detail.value.upper || 0);
    }
    const [location, setLocation] = useState<any | null>(params?.location || '');

    //RECENT SEARCHES
    const [recentSearches, setRecentSearches] = useState<RecentSearch[]>([]);
    const [showRecentSearches, setShowRecentSearches] = useState(false);

    const [sort, setSort] = useState('');

    useEffect(() => {
        const loadRecentSearches = async () => {
            const { value } = await Preferences.get({ key: 'recentSearches' });
            if (value) {
                setRecentSearches(JSON.parse(value));
            }
        };

        loadRecentSearches();
    }, []);

    // Update the history state whenever the state variables change
    useEffect(() => {
        history.replace({
            pathname: history.location.pathname,
            state: { ...params, location, priceMin, priceMax },
        });
    }, [location, priceMin, priceMax]);

    const clearFilters = () => {
        setLocation('');
        setPriceMin(0);
        setPriceMax(0);
    }

    const [buffer, setBuffer] = useState(0.06);
    const [progress, setProgress] = useState(0);

    const sortResults = (results: any[]) => {
        switch (sort) {
            case 'price-asc':
                return results.sort((a, b) => a.product.price - b.product.price);
            case 'price-desc':
                return results.sort((a, b) => b.product.price - a.product.price);
            case 'name-asc':
                return results.sort((a, b) => a.product.name.localeCompare(b.product.name));
            case 'name-desc':
                return results.sort((a, b) => b.product.name.localeCompare(a.product.name));
            default:
                return results;
        }
    };

    const productFilterCompare = (product: any, category: any) => {
        let res = { product: product, category: {slug: category.slug, name: category.name} };
        if (product.price > priceCeiling)
            setPriceCeiling(parseFloat(product.price) + 1000);
        if (product.price < priceFloor)
            setPriceFloor(parseFloat(product.price) - 1000);

        if (location !== '' && location !== null) {
            let isLocationFound = false;
            if (Array.isArray(product.delivery_locations) && product.delivery_locations.length > 0) {
                product.delivery_locations.filter((loc: any) => {
                    if (loc.location !== '' && loc.location !== null && loc.location.toLowerCase().indexOf(location.toLowerCase()) > -1) {
                        isLocationFound = true;
                    }
                });
            }
            if (isLocationFound) {
                if (priceMax !== 0) {
                    if (product.price >= priceMin && product.price <= priceMax)
                        setSearchResults(prev => sortResults([...prev, res]));
                } else
                    setSearchResults(prev => sortResults([...prev, res]));
            }
        }
        else {
            if (priceMax !== 0) {
                if (product.price >= priceMin && product.price <= priceMax)
                    setSearchResults(prev => sortResults([...prev, res]));
            } else
                setSearchResults(prev => sortResults([...prev, res]));
        }
    }
    //Send search call to backend
    const [searchPage, setSearchPage] = useState(0);
    const [searchTotalPage, setSearchTotalPage] = useState(0);
    const searchCall = async (keyword: any = query , page = searchPage + 1, resetResults = false) => {
        if(!keyword) return;

        if (searchTotalPage > 0 && page > searchTotalPage) {
            return;
        }

        setProgress(0);
        setBuffer(0.06);

        // Set progress to 25% when fetching starts
        setProgress(0.25);

        // If resetting results, clear them first
        if (resetResults) {
            setSearchResults([]);
        }

        let payload = {
            searchTerm: keyword,
            captchaToken: '',
            captchaAction: 'SEARCH',
            page: page
        };

        await getCaptchaToken('PAYMENT').then((token: any) => { // Here wait token generated
            if (token) {
                payload.captchaToken = token;
            }
        });
        await axiosCall("/api/searchInventory", 'post', payload)
        .then(async(res) => {

            let hay = res.data.data.data;
            if (res && res.data.data && res.data.status === 1 && hay.length > 0) {
                hay.filter((product: any) => {
                    let category = {slug: product?.category_name, name: product?.category_des};
                    productFilterCompare(product, category);
                });
            }
            setSearchPage(res.data.data.current_page);
            setSearchTotalPage(res.data.data.last_page);
        })
        .catch((error) => {
            console.log(error);
        }).finally(() => {
            /* Set progress to 100% when fetching ends
            setProgress(1);
            setBuffer(0);
            */

            // Increment progress by 25% every half second after fetching is complete
            const interval = setInterval(() => {
                setProgress((prevProgress) => prevProgress >= 1 ? 1 : prevProgress + 0.25);
                setBuffer((prevBuffer) => prevBuffer >= 1 ? 1 : prevBuffer + 0.25);
            }, 500);

            // Clear interval when progress reaches 100%
            if (progress >= 1) {
                clearInterval(interval);
            }
        });
    }

    const filter = async (data: any, backendData: any = null) => {

        setSearchResults([]);
        data = data?.toLowerCase();

        let hay = products;

        const tempResults = hay.filter((category: any) => {
            category.products.filter((product: any) => {
                if (product.description.toLowerCase().indexOf(data) > -1 || product.name.toLowerCase().indexOf(data) > -1) {
                    productFilterCompare(product, {slug: category.slug, name: category.name});
                }
            });

            setQuery(data);

        });
    }

    useEffect(() => {
        // Update the history state whenever the query changes
        history.replace({
            pathname: history.location.pathname,
            state: { ...params, data: query },
        });
    }, [query]);

    useEffect(() => {
        if (products.length < 1)
            return;

        //filter(query);

    }, [products]);

    useEffect(() => {
        const checkForSavedState = async () => {
            if (query !== '' && query !== null) {
                // Check if we have saved state before initiating a new search
                const key = `session_searchFetchState-${query}-${location}`;
                const { value } = await Preferences.get({ key });
                
                // Only run search if there's no valid saved state
                if (!value) {
                    //Wait for 2 seconds before calling searchCall to finish grecaptcha to load
                    setTimeout(() => {
                        searchCall(query, 1, true);
                    }, 2000);
                }
            }
        };
        
        checkForSavedState();
    }, []);

    useEffect(() => {
        setSearchResults(prev => sortResults([...prev]));
    }, [sort]);

    const fetchMore = async (e: { target: { complete: () => void; }; }) => {

        if (searchTotalPage > 0 && searchPage >= searchTotalPage) {
            e.target.complete();
            return;
        }

        // Increment the amount loaded by 6 for the next iteration
        setAmountLoaded(prevAmount => {
            const newAmount = prevAmount + 6;

            // Store using Capacitor Preferences with a prefix to identify session-only data
            const stateToSave = {
                amountLoaded: newAmount,
                searchResults,
                timestamp: Date.now() // Add a timestamp to enable cleanup of old sessions
            };

            // Save with a session prefix to identify temporary data
            Preferences.set({
                key: `session_searchFetchState-${query}-${location}`,
                value: JSON.stringify(stateToSave)
            });

            return newAmount;
        });

        searchCall();

        e.target.complete();
    }

    const searchProducts = async () => {

        const searchVal = query;

        if (searchVal === '' && location === '') {
            return;
        }

        //filter(searchVal);
        
        searchCall(searchVal, 1, true);

        Preferences.remove({ key: `session_searchFetchState-${query}-${location}` });

        // Update recent searches
        let updatedRecentSearches = [...recentSearches];
        if (!updatedRecentSearches.some(search => search.name === searchVal && search.place === location)) {
            updatedRecentSearches.unshift({ name: searchVal, place: location, min_price: priceMin, max_price: priceMax });
            if (updatedRecentSearches.length > 5) {
                updatedRecentSearches = updatedRecentSearches.slice(0, 5);
            }
            setRecentSearches(updatedRecentSearches);
            await Preferences.set({ key: 'recentSearches', value: JSON.stringify(updatedRecentSearches) });
        }
    }

    const handleSearchFocus = () => {
        setShowRecentSearches(true);
    };

    const handleSearchBlur = () => {
        setTimeout(() => {
            setShowRecentSearches(false)
        }, 200);
    };

    const clickRecent = async (re: RecentSearch) => {

        const searchVal = re.name;
        setQuery(searchVal);

        if (re.place) {
            setLocation(re.place);
        }

        if (searchVal !== "") {
            //filter(searchVal);
            searchCall(searchVal, 1, true);
            Preferences.remove({ key: `session_searchFetchState-${query}-${location}` });
        }
    };

    const handleSortChange = (e: any) => {
        setSort(e.detail.value);
    };

    // Restore state when entering the view
    useIonViewDidEnter(() => {
        const restoreFetchState = async () => {
            const key = `session_searchFetchState-${query}-${location}`;
            const { value } = await Preferences.get({ key });

            if (value) {
                try {
                    const savedState = JSON.parse(value);

                    // Check if the saved state is from the current session (within 5 minutes)
                    const isCurrentSession = savedState.timestamp &&
                        (Date.now() - savedState.timestamp < 5 * 60 * 1000);

                    if (isCurrentSession) {
                        if (savedState.searchResults && savedState.searchResults.length > 0) {
                            setSearchResults(savedState.searchResults);
                        }

                        if (savedState.amountLoaded) {
                            setAmountLoaded(savedState.amountLoaded);
                        }
                    } else {
                        // Clean up expired session data
                        await Preferences.remove({ key });
                    }
                } catch (error) {
                    console.error("Error restoring fetch state:", error);
                }
            }
            setProgress(1);
            setBuffer(0);
        };

        restoreFetchState();
    });

    return (

        <IonPage id="category-page" className={styles.categoryPage}>
            <IonHeader>
                <IonToolbar>

                    <IonButtons slot="end">
                        <IonBadge color="dark">
                            {shopCart.length}
                        </IonBadge>
                        <IonButton color="dark" routerLink="/cart">
                            <IonIcon ref={cartRef} className="animate__animated" icon={cart} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>

            </IonHeader>

            <IonContent className="scroll-position-capture page-content">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="dark" routerLink="/" routerDirection="back">
                            <IonIcon color="dark" icon={chevronBackOutline} />&nbsp;Back
                        </IonButton>
                    </IonButtons>

                    <IonButtons slot="end" class="ion-padding-left">
                        <IonButton color="drukre" routerLink="/cart">
                            {shopCart.length}
                            <IonIcon ref={cartRef} className="animate__animated" icon={cartOutline} />
                        </IonButton>
                    </IonButtons>
                </IonToolbar>

                <IonGrid>
                    <IonRow>
                        <IonCol size='9'>
                            <IonRow>
                                <IonCol>
                                    <IonSearchbar className={styles.search}
                                        onIonInput={e => setQuery(e.target.value)} value={query}
                                        placeholder="Search for" searchIcon={searchOutline} animated={true}
                                        onIonFocus={handleSearchFocus}
                                        onIonBlur={handleSearchBlur}
                                    />
                                    {showRecentSearches && recentSearches.length > 0 && <IonCardSubtitle>Recent Searches</IonCardSubtitle>}
                                    {showRecentSearches && recentSearches.map((product, index) => (
                                        <IonButton fill="outline" color="medium" size="default"
                                            style={{ textTransform: 'none' }}
                                            key={index}
                                            onClick={(ev) => clickRecent(product)}>
                                            <IonLabel>
                                                <IonText>{product?.name?.length > 10 ? product.name.substring(0, 10) + '..' : product.name}</IonText>
                                                {product.place && <small> in {product.place.length > 10 ? product.place.substring(0, 10) : product.place}</small>}
                                                {/*}
                                                    <p>{prevFilterData.min_price ? 'Min $ '+prevFilterData.min_price : null}</p>
                                                */}
                                            </IonLabel>
                                        </IonButton>
                                    ))}
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol sizeMd="6" sizeLg="6" sizeSm="12" sizeXs="12" className="ion-padding-horizontal">
                                    <IonInput type="text" value={location} label="Enter Location" labelPlacement="floating" onIonInput={e => setLocation(e.detail.value)}></IonInput>
                                </IonCol>
                                <IonCol sizeMd="6" sizeLg="6" sizeSm="12" sizeXs="12" className="ion-padding-horizontal">
                                    <IonRange
                                        aria-label="Price Range"
                                        labelPlacement="start" label="Price Range"
                                        dualKnobs={true}
                                        value={{
                                            lower: priceMin,
                                            upper: priceMax
                                        }}
                                        min={priceFloor}
                                        max={priceCeiling}
                                        onIonChange={(e) => priceKnobChange(e)}
                                    ></IonRange>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol offsetMd="4" offsetLg="4" sizeMd="3" style={{ textAlign: 'center' }}>
                                    <IonNote> Min: Nu. {priceMin}  - </IonNote>
                                </IonCol>
                                <IonCol sizeMd="3" style={{ textAlign: 'center' }}>
                                    <IonNote>Max: Nu. {priceMax} </IonNote>
                                </IonCol>
                            </IonRow>
                        </IonCol>
                        <IonCol size='2' className="ion-align-self-center">
                            <IonButton color="drukre" size="large" onClick={() => clearFilters()}>
                                <IonIcon icon={closeOutline} />&nbsp;
                                <span className="ion-hide-md-down">Clear</span>
                            </IonButton>
                            <IonButton color="drukre" size="large" onClick={() => searchProducts()}>
                                <IonIcon icon={search} />&nbsp;
                                <span className="ion-hide-md-down">Search</span>
                            </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol>
                            <IonProgressBar color='drukre' buffer={buffer} value={progress}></IonProgressBar>
                        </IonCol>
                    </IonRow>
                    <IonRow className="ion-text-center">
                        <IonCol sizeMd="6" sizeSm="3" className="ion-align-self-center">
                            <IonNote>{searchResults && searchResults.length} {(searchResults.length > 1 || searchResults.length === 0) ? " products" : " product"} found</IonNote>
                        </IonCol>
                        <IonCol sizeMd="6" sizeSm="9">
                            <IonRow>
                                <IonCol sizeSm="4" sizeMd="2" offsetXs="2" offsetSm="2" offsetMd="7" className="ion-align-self-center">
                                    <IonLabel>Sort By:</IonLabel>
                                </IonCol>
                                <IonCol sizeSm="6" sizeMd="3">
                                    <IonSelect value={sort} placeholder="Select Sort" onIonChange={handleSortChange}>
                                        <IonSelectOption value="price-asc">Price: Low to High</IonSelectOption>
                                        <IonSelectOption value="price-desc">Price: High to Low</IonSelectOption>
                                        <IonSelectOption value="name-asc">Name: A to Z</IonSelectOption>
                                        <IonSelectOption value="name-desc">Name: Z to A</IonSelectOption>
                                    </IonSelect>
                                </IonCol>
                            </IonRow>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        {searchResults && searchResults.map((product, index) => {

                            if ((index <= amountLoaded) && product.product.images) {
                                return (
                                    <IonCol sizeSm="6" sizeMd="3" key={`search_product_${index}`}>
                                        <ProductCard key={`search_product_${index}`} product={product.product} category={product.category} index={index} cartRef={cartRef} />
                                    </IonCol>
                                );
                            }
                        })}
                    </IonRow>
                </IonGrid>

                <IonInfiniteScroll threshold="100px" onIonInfinite={fetchMore}>
                    <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Fetching more...">
                    </IonInfiniteScrollContent>
                </IonInfiniteScroll>
            </IonContent>
        </IonPage>
    );
}

export default SearchProducts;